/* @flow */

import { partial } from 'ramda';

import { assertString } from '@e180/util/lib/assert';

export const FMP = 'first-meaningful-paint';

export function markPerformance(name: string) {
  assertString(name, 'name');

  if (
    typeof window !== 'undefined' &&
    window.performance &&
    typeof window.performance === 'object' &&
    typeof window.performance.mark === 'function'
  ) {
    window.performance.mark(name);
  } else {
    // throw new Error("performance.mark is not supported");
  }
}

export const markFMP = partial(markPerformance, [FMP]);
